"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PrettyChoices_1 = require("./PrettyChoices");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return PrettyChoices_1.default; } });
